// fonts
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/600.css';
import '@fontsource/inter/500.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './src/styles/global.css';

import React from 'react';
import Layout from './src/components/Layout';

export const wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
);

// ---- Top loading bar ----
function getBar() {
  let bar = document.getElementById('top-loading-bar');
  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'top-loading-bar';
    Object.assign(bar.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '0%',
      height: '3px',
      background: 'linear-gradient(90deg, #ffa335, #1d6ec7)',
      zIndex: '99999',
      transition: 'width 0.4s ease',
      boxShadow: '0 0 8px rgba(255,163,53,0.5)',
      pointerEvents: 'none',
    });
    document.body.appendChild(bar);
  }
  return bar;
}

let loadingTimer = null;

export const onPreRouteUpdate = () => {
  const bar = getBar();
  bar.style.transition = 'width 0.4s ease';
  bar.style.opacity = '1';
  bar.style.width = '30%';
  loadingTimer = setTimeout(() => {
    bar.style.width = '70%';
  }, 300);
};

export const onRouteUpdate = () => {
  if (loadingTimer) clearTimeout(loadingTimer);
  const bar = getBar();
  bar.style.transition = 'width 0.2s ease';
  bar.style.width = '100%';
  setTimeout(() => {
    bar.style.transition = 'opacity 0.3s ease';
    bar.style.opacity = '0';
    setTimeout(() => {
      bar.style.width = '0%';
    }, 300);
  }, 200);
};
